export default __webpack_public_path__ + "static/GASTOS_MÉDICOS-f0399567297fadca20d0763d9843a5df.png";